app.controller("adminController", [
	"$scope",
    "$state",
    "$stateParams",
    "Session",
    "NOTIFICATIONS_UPGRADE_1067",
    function ($scope, $state, $stateParams, Session, NOTIFICATIONS_UPGRADE_1067) {
        $scope.notificationsUpgradeEnabled = NOTIFICATIONS_UPGRADE_1067;

        $scope.isAdminRole = !!(Session.user && Session.user.roles && Session.user.roles.includes("ADMIN"));
        if(!$stateParams.type || !$scope.isAdminRole){
            $state.go("welcome");
            return;
        }
        $scope.consoleType = $stateParams.type;
        // $scope.$ctrl.consoleType = $stateParams.type;
	},
]);
